/**
 * OAuth Utilities (Squares)
 *
 * Thin wrapper around shared OAuth utils from @low6-pickem/frontend-shared.
 * Provides app-specific config (API URL, tenant slug) so callers
 * can continue to call initiateOAuthLogin() with no arguments.
 */

import {
  initiateOAuthLogin as sharedInitiateOAuthLogin,
  resolveTenantFromUrl,
} from '@low6-pickem/frontend-shared';

export { extractOAuthParams } from '@low6-pickem/frontend-shared';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/** Initiate OAuth login with app-specific config */
export async function initiateOAuthLogin(): Promise<void> {
  return sharedInitiateOAuthLogin(API_BASE_URL, resolveTenantFromUrl());
}
